import React from 'react'
import { useValues } from 'kea'

import LessonReview from '~/scenes/shared/lesson-review'

import railsContext from 'lib/selectors/rails-context'
import sceneLogic from '~/scenes/search/logic'
import { useSelector } from 'react-redux'

import './styles.scss'

function LessonReviews () {
  const { dpr } = useSelector(railsContext)
  const {
    results: { reviews, reviews_meta: reviewsMeta }
  } = useValues(sceneLogic)

  const { header, description, description_2: description2, rating } = reviewsMeta

  return reviewsMeta ? (
    <div id='search-lesson-reviews'>
      <div className='grid'>
        <div className='col-1-1'>
          <div className='review-title'>
            <h2>{header}</h2>
            <h3>
              {description}
              <br />
              {description2} {rating ? <span dangerouslySetInnerHTML={{ __html: rating }} /> : null}
            </h3>
          </div>
        </div>
      </div>
      <div className='grid review-part'>
        {reviews.map(review => (
          <div className='col-1-3' key={review.id}>
            <LessonReview isSearchPage dpr={dpr} review={review} />
          </div>
        ))}
      </div>
    </div>
  ) : null
}

export default React.memo(LessonReviews)
